<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs6>
        <v-textarea
          v-model="encoded"
          label="Encoded HTML"
          auto-grow
          box
        ></v-textarea>
        <v-btn @click="convert">Convert</v-btn>
      </v-flex>
      <v-flex xs6>
        <iframe id="decoded"></iframe>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// import Bus from '@/bus'
import ApiMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import DisplayMixin from '@/mixins/display'
import StoreMixin from '@/store/mixin'

export default {
  mixins: [ApiMixin, AuthMixin, DisplayMixin, StoreMixin],

  data: function () {
    return {
      encoded: ''
    }
  },

  created () {
    if (!this.hasPermission('superuser')) {
      this.$store.commit('error', 'Access Denied')
      this.$router.go(-1)
    }
  },

  mounted () {
  },

  destroyed () {
  },

  computed: {
  },

  watch: {
  },

  methods: {
    convert: function () {
      let buffer = Buffer.from(this.encoded, 'base64')
      let frame = document.getElementById('decoded').contentWindow.document
      frame.open()
      frame.write(buffer.toString('ascii'))
      frame.close()
    }
  }
}
</script>

<style>
#decoded {
  height: 100%;
  resize: both;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/manage/utilities/EmailDecode.vue